import { createSlice } from "@reduxjs/toolkit";
import { 
  getFillFlow, 
  createFillFlow, 
  updateFillFlow, 
  deleteFillFlow, 
  clearLocalActiveFillFlow
} from "./actions";

export const initialState = {
  fillFlow: { 
    id: '', 
    email: '', 
    context: '', 
    updated_at: '' 
  },
  loading: false
};

const slice = createSlice({
  name: 'fillFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getFillFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFillFlow.fulfilled, (state, action) => {
        const { fill_flow } = action.payload;
        const fillFlow = { ...state.fillFlow, ...fill_flow };

        state.loading = false;
        state.fillFlow = fillFlow;
      })
      .addCase(getFillFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createFillFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createFillFlow.fulfilled, (state, action) => {
        const { fill_flow } = action.payload;

        state.loading = false;
        state.fillFlow = fill_flow;      
      })
      .addCase(createFillFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateFillFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateFillFlow.fulfilled, (state, action) => {
        const { status, fill_flow } = action.payload;
        const updatedFillFlow = { ...state.fillFlow, ...fill_flow };

        state.loading = false;
        if (status === 204) state.fillFlow = updatedFillFlow;      
      })
      .addCase(updateFillFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteFillFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFillFlow.fulfilled, (state, action) => {
        const { status } = action.payload;

        state.loading = false;
        if (status === 204) state.fillFlow = initialState.fillFlow;    
      })
      .addCase(deleteFillFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveFillFlow, state => {
        state.fillFlow = initialState.fillFlow;
      })
  }
})

export default slice.reducer;